import Lottie from "lottie-react";
import Loader from "../../assets/Lottie/moving_car.json";



const LoadingComponent = () => {
  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div style={{ width: "250px" }}>
        <Lottie animationData={Loader} loop={true} />
      </div>
    </div>
  );
};
export default LoadingComponent;


//   return (
//     <div className="d-flex justify-content-center align-items-center vh-100">
//       <div style={{ width: "200px", transform: "translateY(120px)" }}>
//         <Lottie animationData={Loader} loop={true} />
//       </div>
//     </div>
//   );
// };